import React from 'react';
import styles from './ConfirmDeleteModal.module.css';
import Button from './Button';

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  transactionName: string;
  amount: number;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  transactionName,
  amount
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.modalOverlay} onClick={onCancel}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h2 className={styles.title}>Delete Transaction?</h2>
        <p className={styles.message}>
          Are you sure you want to delete this transaction?
        </p>
        <div className={styles.transactionInfo}>
          <div className={styles.transactionName}>{transactionName}</div>
          <div className={styles.transactionAmount}>${Math.abs(amount).toFixed(2)}</div>
        </div>
        <p className={styles.warning}>This action cannot be undone.</p>
        <div className={styles.buttonContainer}>
          <Button onClick={onConfirm} className={styles.deleteButton}>
            Yes, Delete
          </Button>
          <Button onClick={onCancel} className={styles.cancelButton}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
